import styled from 'styled-components';
import { Avatar, MetaRow } from '@/ui';

const Row = styled.div` display: flex; align-items: center; gap: 10px; `;
const Text = styled.div` display: flex; align-items: baseline; gap: 6px; flex-wrap: wrap; min-width: 0; `;
const Name = styled.span` color: ${({ theme }) => theme.color.textPrimary}; font-weight: 600; font-size: ${({ theme }) => theme.fontSize.sm}; `;
const Handle = styled.span` color: ${({ theme }) => theme.color.textMuted}; font-size: ${({ theme }) => theme.fontSize.xs}; `;
const Time = styled.span` color: ${({ theme }) => theme.color.textMuted}; font-size: ${({ theme }) => theme.fontSize.xs}; `;

export function HubIdentity({ name, handle, av, time }: { name: string; handle: string; av: string; time?: string }) {
  return (
    <Row>
      <Avatar name={name} avatarKey={av} size={34} />
      <Text>
        <Name>{name}</Name>
        <MetaRow>
          <Handle>{handle}</Handle>
          {time && <Time>{time}</Time>}
        </MetaRow>
      </Text>
    </Row>
  );
}
